import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
    generalLayout: {
        padding: "0 5%",
    },
    increaseTopSpace: { marginTop: 105 },
    addMarginTopToVerticalTab: {
        "& .MuiPaper-root": { top: 111 },
    },
    addMarginTop: { marginTop: 40 },
    componentsContainer: {
        minHeight: "calc(100vh - 330px)",
        paddingTop: 100,
        boxSizing: "border-box",
    },
    dashboardContainers: {
        margin: "0 60px 0 120px",
    },
});
